export const blogTranslations = {
  BLOG_TITLE: 'Inspiration',
  BLOG_SUBTITLE: 'Read, learn and be inspired!'
}
